import styled from 'styled-components';

const HistoricalVisitDiagnosis = styled.div`
   min-height: 70px;
`;

HistoricalVisitDiagnosis.displayName = 'HistoricalVisitDiagnosis';

export { HistoricalVisitDiagnosis };
